import type { FormBranchComparison } from '../types';

const matches = (value: string, condition: FormBranchComparison) => {
  if (!condition.value) return false;
  switch (condition.op) {
    case 'equals':
      return value === condition.value;
    case 'not_equals':
      return value !== condition.value;
    case 'greater_than':
      return Number(value) > Number(condition.value);
    case 'less_than':
      return Number(value) < Number(condition.value);
    case 'greater_than_or_equal':
      return Number(value) >= Number(condition.value);
    case 'less_than_or_equal':
      return Number(value) <= Number(condition.value);
    // A branch node never offers these; counting them as a match keeps Default from listing a value
    // a case may take.
    case 'in':
    case 'not_in':
      return true;
  }
};

const getUnmatchedValues = (values: string[], conditions: FormBranchComparison[]) =>
  values.filter(value => !conditions.some(condition => matches(value, condition)));

export default getUnmatchedValues;
